if (!customElements.get('nora-ingredient-tabs')) {
  customElements.define(
    'nora-ingredient-tabs',
    class NoraIngredientTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.tabs.forEach((tab, index) => tab.addEventListener('click', () => this.select(index)));
        this.querySelector('[role="tablist"]').addEventListener('keydown', (e) => this.onKey(e));

        this.onBlockSelect = (e) => {
          const index = this.tabs.findIndex((tab) => tab.contains(e.target) || tab === e.target);
          if (index >= 0) this.select(index, false);
        };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
      }

      disconnectedCallback() {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onKey(e) {
        const current = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        let next = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') next = (current + 1) % this.tabs.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') next = (current - 1 + this.tabs.length) % this.tabs.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = this.tabs.length - 1;
        if (next === null) return;
        e.preventDefault();
        this.select(next, true);
      }

      select(index, focus = true) {
        this.tabs.forEach((tab, i) => {
          const on = i === index;
          tab.setAttribute('aria-selected', on ? 'true' : 'false');
          tab.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) this.tabs[index].focus();
      }
    }
  );
}
